import * as React from 'react'

import Comment from './Comment'

export interface CommentData {
  readonly id: string
  readonly name: string
  readonly content: string
}

export interface Props {
  comments: Array<CommentData>
  style?: React.CSSProperties
  className?: string
}

export default class CommentList extends React.Component<Props> {
  render () {
    return this.props.comments.length ? (
      <div
        className={
          'p1 flex flex-column border-box' + this.props.className ? (
            this.props.className
          ) : (
            ''
          )
        }
        style={{
          justifyContent: 'flex-end',
          overflowY: 'scroll',
          ...this.props.style ? this.props.style : {}
        }}>
        {this.props.comments.map(comment => {
          const { id, ...props } = comment
          return <Comment key={id} {...props} />
        })}
      </div>
    ) : (
      <div className='flex items-center' style={{ height: '100%' }}>
        <div className='center h2 flex-auto'>Be the first to comment! ✌️</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CommentList.tsx